import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { VMenu } from '../../../../../components/shared';
import { LayoutBase } from '../../../../../layouts';
import { FilesTable, ToolsListing } from '../../../../../components/custom';
import { useEffect, useState } from 'react';
import { FileServicesBack, IFileServices } from '../../../../../services/api/files/FileServicesBack';
import { CustomAlert } from '../../../../../components/shared/VAlert';
import { useAuthContext } from '../../../../../context';

export const DamSafetyInspectionsPlanning = () => {

    const url = useParams();
    const [historico, setHistorico] = useState<boolean>(false);
    const [dataFilter, setDataFilter] = useState<IFileServices[]>();
    const [data, setData] = useState<IFileServices[]>();
    const [isDialogOpen, setDialogOpen] = useState(false);
    const navigate = useNavigate();
    const { userData } = useAuthContext();
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });

    async function sortedData() {
        if (dataFilter) {
            const sorted = dataFilter.slice().sort((a, b) => {
                if (a.data_emissao && b.data_emissao) {
                    const dateA = new Date(a.data_emissao).getTime();
                    const dateB = new Date(b.data_emissao).getTime();
                    if (sortDirection === 'asc') {
                        setSortDirection('desc');
                        return dateA - dateB;
                    } else {
                        setSortDirection('asc');
                        return dateB - dateA;
                    }
                }
                return 0;
            });
            setDataFilter(sorted);
        }
    }

    useEffect(() => {
        fetchData();
    }, [url, historico]);

    const fetchData = () => {
        if (url.id) {
            if (!historico) {
                FileServicesBack.get(url.id)
                    .then((result) => {
                        if (result instanceof Error) {
                            setAlertInfo({ open: true, message: 'Não foi possível obter os dados dos documentos! ' + result.message, severity: 'error' });
                        } else {
                            const value = result.filter(index => index.status === true);
                            const valueToData = value.filter(index => index.tipo && index.tipo.tipo === 'Fichas de Inspeções de Segurança de Barragens (histórico)');
                            setData(valueToData);
                            setDataFilter(valueToData);
                        }
                    });
            } else {
                FileServicesBack.get(url.id)
                    .then((result) => {
                        if (result instanceof Error) {
                            setAlertInfo({ open: true, message: 'Não foi possível obter os dados dos documentos! ' + result.message, severity: 'error' });
                        } else {
                            setData(result);
                        }
                    });
            }
        }
    };

    const showAlert = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
        setAlertInfo({ open: false, message: '', severity: 'info' });
        setTimeout(() => {
            setAlertInfo({ open: true, message, severity });
        }, 100);
    };

    async function handleDelete(valueId: string | undefined) {
        if (valueId !== undefined) {
            FileServicesBack.deleteById(valueId)
                .then((result) => {
                    if (result instanceof Error) {
                        showAlert('Não foi possível excluir o documento! ' + result.message, 'error');
                    } else {
                        showAlert('Documento excluído!', 'success');
                        fetchData();
                        handleCloseDialog();
                    }
                });
        }
    }

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const toggleDialog = () => {
        setDialogOpen(!isDialogOpen);
    };

    function handleFileType(newValue: string[] | null) {
        if (newValue !== null) {
            if (newValue.length > 0) {
                if (dataFilter) {
                    const filteredData = dataFilter.filter(index => {
                        const tipo = index.tipo?.tipo || '';
                        const normalizedTipo = tipo.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                        return newValue.some(value => {
                            const normalizedValue = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                            return normalizedTipo.includes(normalizedValue);
                        });
                    });
                    setDataFilter(filteredData);
                }
            } else {
                setDataFilter(data);
            }
        } else {
            setDataFilter(data);
        }
    }

    function handleHistorico() {
        setHistorico(!historico);
    }

    function handleEditFile(key: string | undefined) {
        if (key !== undefined) {
            navigate(`/information_dam/${url.id}/files/file/${key}`);
        }
    }

    return (
        <LayoutBase
            title='Planejamento Inspeções e Segurança'
            tollBar={
                <ToolsListing
                    showNewButton={userData.permissoes.includes('add')}
                    onClickNew={() => navigate(`/information_dam/${url.id}/files/fisb/new`)}
                />
            }
        >
            <Box width={'100%'}>
                <VMenu id={url.id} />
                <Box width={'100%'}>
                    <FilesTable
                        title='Arquivos de Seguraça'
                        url={url}
                        dataFilter={dataFilter}
                        handleDelete={handleDelete}
                        handleFileType={handleFileType}
                        handleHistorico={handleHistorico}
                        sortedData={sortedData}
                        isDialogOpen={isDialogOpen}
                        toggleDialog={toggleDialog}
                        handleEditFile={handleEditFile}
                    />
                </Box>
            </Box>
            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                />
            }
        </LayoutBase>
    );
};